
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class LogFuctionLvAppDialog extends Serenity.EntityDialog<LogFuctionLvAppRow, any> {
        protected getFormKey() { return LogFuctionLvAppForm.formKey; }
        protected getIdProperty() { return LogFuctionLvAppRow.idProperty; }
        protected getLocalTextPrefix() { return LogFuctionLvAppRow.localTextPrefix; }
        protected getNameProperty() { return LogFuctionLvAppRow.nameProperty; }
        protected getService() { return LogFuctionLvAppService.baseUrl; }
        protected getDeletePermission() { return LogFuctionLvAppRow.deletePermission; }
        protected getInsertPermission() { return LogFuctionLvAppRow.insertPermission; }
        protected getUpdatePermission() { return LogFuctionLvAppRow.updatePermission; }

        protected form = new LogFuctionLvAppForm(this.idPrefix);


        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            //    buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            return buttons;


        }
    }
}